import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { removeAccessToken, setAccessToken } from '@pages/auth/handleToken';
import seathruApi from '@src/lib/axios';

export const login = createAsyncThunk('auth/login', async (params, { rejectWithValue }) => {
  try {
    const { data } = await seathruApi({
      url: '/api/auth/login',
      method: 'post',
      data: params,
    });

    return data.data;
  } catch (err) {
    if (!err.response) {
      throw err;
    }

    return rejectWithValue(err.response.data);
  }
});

export const logout = createAsyncThunk('auth/logout', async (params, { rejectWithValue }) => {
  try {
    const { data } = await seathruApi({
      url: '/api/auth/logout',
      method: 'post',
    });

    return data.data;
  } catch (err) {
    if (!err.response) {
      throw err;
    }

    return rejectWithValue(err.response.data);
  }
});

export const me = createAsyncThunk('auth/me', async (params) => {
  const { data } = await seathruApi({
    url: '/api/auth/me',
    method: 'get',
  });

  return data;
});

export const { actions, reducer } = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    loading: true,
    error: {},
  },
  reducers: {
    updateAuthState: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    setUser: (state, { payload }) => {
      state.user = payload;
    },
  },
  extraReducers: (builder) => {
    // login
    builder.addCase(login.pending, (state) => {
      state.error = {};
    })
      .addCase(login.fulfilled, (state, { payload }) => {
        setAccessToken(payload.access_token);
        state.user = payload.user;
        state.error = {};
      })
      .addCase(login.rejected, (state, { payload }) => {
        state.error = {
          code: payload.error_code,
          message: payload.message,
        };
      });

    // logout
    builder.addCase(logout.pending, (state) => {
      state.error = {};
    })
      .addCase(logout.fulfilled, (state) => {
        removeAccessToken();
        state.user = null;
        state.error = {};
      })
      .addCase(logout.rejected, (state, { payload }) => {
        state.error = {
          code: payload.error_code,
          message: payload.message,
        };
      });

    // me
    builder.addCase(me.pending, (state) => {
      state.loading = true;
    })
      .addCase(me.fulfilled, (state, { payload }) => {
        state.user = payload.data;
        state.loading = false;
      })
      .addCase(me.rejected, (state) => {
        state.loading = false;
        state.user = null;
      // window.localStorage.removeItem('accessToken');
      });
  },
});

export const { updateAuthState, setUser } = actions;

export default reducer;
